/**
 * @file Map Redux state to compose props
 */

import { MapStateToProps } from 'react-redux';

import AppState from '../../models/state';

import { getIsDefaultDraftChanged, getIsDraftChanged } from './helpers';

import { OwnProps, StateProps } from './props';

/**
 * Map Redux state to compose props
 *
 * @param appState                   Global Redux state
 * @param appState.drafts            Drafts in Redux store
 * @param appState.draftsAttachments Attachments Drafts in Redux store
 * @param ownProps                   Props passed to compose container
 * @param ownProps.nodeType          The ID of the draft
 * @returns                          Props to add to compose
 */
const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  { drafts, draftsAttachments },
  { nodeType },
) => {
  return {
    dataDraft: drafts.get(nodeType),
    isDefaultDraftChanged: getIsDefaultDraftChanged(
      drafts.get(nodeType),
      draftsAttachments.get(nodeType),
    ),
    isDraftChanged: getIsDraftChanged(
      drafts.get(nodeType),
      draftsAttachments.get(nodeType),
    ),
  };
};

export default mapStateToProps;
